var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockTakeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4452",
    "data-name": "Rectangle 4452",
    width: 24,
    height: 24,
    transform: "translate(65 544)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3042",
    d: "M0-682.665H18.4v18.4H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stock_take",
    "data-name": "Stock take",
    transform: "translate(-65 -544)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3036",
    transform: "translate(67.8 1229.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3038",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3040",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3046",
    transform: "translate(0.719 9.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3048",
    d: "M-311.374-259.478v-5.75a1.438,1.438,0,0,0-1.438-1.438h-5.75A1.438,1.438,0,0,0-320-265.228v5.75a1.438,1.438,0,0,0,1.438,1.438h5.75A1.438,1.438,0,0,0-311.374-259.478Z",
    transform: "translate(319.999 266.666)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3050",
    transform: "translate(4.888 0.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3052",
    d: "M-311.374-207.583V-211.9a1.438,1.438,0,0,0-1.438-1.438h-5.75A1.438,1.438,0,0,0-320-211.9v4.313",
    transform: "translate(319.999 213.333)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3054",
    transform: "translate(3.594 11.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3056",
    d: "M0,0V1.438H2.875V0",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3058",
    transform: "translate(7.763 3.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3060",
    d: "M0,0V1.438H2.875V0",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3062",
    transform: "translate(11.685 9.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3064",
    d: "M0-311.374H4.559A1.438,1.438,0,0,0,6-312.812v-5.75A1.438,1.438,0,0,0,4.559-320H0",
    transform: "translate(0 319.999)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3066",
    transform: "translate(11.932 11.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3068",
    d: "M0,0V1.438H2.875V0",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockTakeIcon);
export default __webpack_public_path__ + "static/media/Stock_take_Icon.6ad325e836427eb26cedb2d488bff388.svg";
export { ForwardRef as ReactComponent };